module.exports = __webpack_public_path__ + "img/PVProductionService.3dd79c2c.png";